export enum ITeamAnalyticsEventEnum {
  Id = 'TeamAnalyticsEvent.id',
  AccountId = 'TeamAnalyticsEvent.accountid',
  UserId = 'TeamAnalyticsEvent.userid',
  Count = 'TeamAnalyticsEvent.count',
  TotalDuration = 'TeamAnalyticsEvent.totalDuration',
  MaxDuration = 'TeamAnalyticsEvent.maxDuration',
  UserCount = 'TeamAnalyticsEvent.userCount',
  Duration = 'TeamAnalyticsEvent.duration',
  CreatedAt = 'TeamAnalyticsEvent.createdat',
  UpdatedAt = 'TeamAnalyticsEvent.updatedat',
  CreatedBy = 'TeamAnalyticsEvent.createdby',
  UpdatedBy = 'TeamAnalyticsEvent.updatedby',
  DeletedAt = 'TeamAnalyticsEvent.deletedat',
  DeletedBy = 'TeamAnalyticsEvent.deletedby',
  TeamId = 'TeamAnalyticsEvent.teamid',
  EventType = 'TeamAnalyticsEvent.eventtype',
  AppId = 'TeamAnalyticsEvent.appid',
  SubscriptionId = 'TeamAnalyticsEvent.subscriptionid',
  StartTime = 'TeamAnalyticsEvent.starttime',
  LocalStartTime = 'TeamAnalyticsEvent.localstarttime',
  EndTime = 'TeamAnalyticsEvent.endtime',
  ExternalId = 'TeamAnalyticsEvent.externalid',
  Title = 'TeamAnalyticsEvent.title',
  Recurring = 'TeamAnalyticsEvent.recurring',
  AttendeeCount = 'TeamAnalyticsEvent.attendeecount',
  LocalStartDate = 'TeamAnalyticsEvent.localstartdate',
  WeekCount = 'TeamAnalyticsEvent.weekCount',
  DayCount = 'TeamAnalyticsEvent.dayCount',
}
